import { register } from '@shopify/theme-sections';
import Swiper from 'swiper';
import ProductVariants from '../components/ProductVariants';
import QuickAdd from '../components/QuickAdd';
import { waitForElm } from '../helpers/util';

register('featured-products', {
  initCarousel(el) {
    if (!el) return;

    const swiper = new Swiper(el, {
      loop: false,
      observer: true,
      observeParents: true,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      shortSwipes: false,
      watchSlidesProgress: true,
      on: {
        slideChange: (swiper) => {
          swiper.visibleSlides?.forEach((slide) => {
            if (
              slide.querySelector('[data-color-swatches]') != null &&
              slide.querySelector('[data-initialized]') == null
            ) {
              slide
                .querySelector('[data-color-swatches]')
                .setAttribute('data-initialized', 'true');
              let productCard = slide.querySelector('[data-product-card]');
              let productCardItem = new ProductVariants(productCard);
              this.initCard(productCardItem);
            }
          });
        },
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        1600: {
          slidesPerView: 5,
          slidesPerGroup: 3,
          spaceBetween: 15,
          slidesOffsetBefore: 70,
        },
        1400: {
          slidesPerView: 5,
          slidesPerGroup: 3,
          spaceBetween: 15,
        },

        1024: {
          slidesPerView: 4,
          slidesPerGroup: 3,
          spaceBetween: 15,
          slidesOffsetBefore: 20,
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 15,
          slidesOffsetBefore: 20,
        },
        319: {
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 10,
          slidesOffsetBefore: 20,
        },
      },
    });
  },

  initTabs() {
    const tabs = this.container.querySelectorAll('[data-tab-target]');
    const tabContents = this.container.querySelectorAll('[data-tab-content]');
    const tabCarousels = this.container.querySelectorAll('.featured-carousel');

    tabCarousels.forEach((carousel) => {
      this.initCarousel(carousel);
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = this.container.querySelector(tab.dataset.tabTarget);
        tabContents.forEach((tabContent) => {
          tabContent.classList.remove('active');
        });
        tabs.forEach((tab) => {
          tab.classList.remove('active');
        });
        tab.classList.add('active');
        target.classList.add('active');
        setTimeout(() => {
          this.initCards();
        }, 200);
      });
    });
  },

  initCards() {
    const productCards = this.container.querySelectorAll(
      '.swiper-slide-visible [data-product-card]',
    );
    if (!productCards) return;

    productCards.forEach((card) => {
      if (
        card.querySelector('[data-color-swatches]') != null &&
        card.querySelector('[data-initialized]') == null
      ) {
        card
          .querySelector('[data-color-swatches]')
          .setAttribute('data-initialized', 'true');
        let productCardItem = new ProductVariants(card);

        this.initCard(productCardItem);
      }
    });
  },

  hideEmptyReviews() {
    let starsContainers = this.container.querySelectorAll(
      '.inline_rating_container',
    );
    if (starsContainers) {
      waitForElm(
        '.inline_rating_container .bv_main_container',
        this.container,
      ).then(() => {
        starsContainers.forEach((starsContainer) => {
          let emptyStars = starsContainer.querySelectorAll(
            '.bv_stars_svg_no_wrap svg linearGradient[x1="0.00%"]',
          );
          if (emptyStars.length == 5) {
            starsContainer.style.opacity = '0';
          }
        });
      });
    }
  },

  initCard(productCardItem) {
    const quickAdd = new QuickAdd(productCardItem.el);
    let timespend = 0;
    let swatchContainer = productCardItem.el.querySelector(
      '[data-color-swatches]',
    );
    if (swatchContainer != null) {
      let waitVariantsData = setInterval(() => {
        timespend = timespend + 2;
        if (productCardItem.allProductStyles != undefined) {
          let renderedItems = 0;
          let currentItemFounded = false;
          let renderedBadge = productCardItem.buildBadge(
            productCardItem.badgeTags,
          );
          renderedBadge
            ? productCardItem.el
                .querySelector('.product-card__image [data-product-link]')
                .appendChild(renderedBadge)
            : null;
          clearInterval(waitVariantsData);
          for (const product in productCardItem.allProductStyles.products) {
            let swatchProduct =
              productCardItem.allProductStyles.products[product];
            let swatchItem = productCardItem.buildSwatchItem(swatchProduct);
            if (swatchItem) {
              let currentItem =
                productCardItem.data.id == swatchProduct.id ? true : false;
              if (currentItem) {
                swatchItem.classList.add('selected');
                swatchContainer.prepend(swatchItem);
                currentItemFounded = true;
                quickAdd.buildQuickAdd(swatchProduct);
              } else {
                if (renderedItems < 6) {
                  swatchContainer.appendChild(swatchItem);
                  renderedItems++;
                }
              }
              swatchItem.addEventListener('click', (e) => {
                e.preventDefault();
                if (e.currentTarget.classList.contains('selected')) {
                  return false;
                }
                let itemTrack = {
                  Name: swatchProduct.title,
                  ProductID: swatchProduct.id,
                  Categories: swatchProduct.categories,
                  ImageURL: swatchProduct.featuredImage,
                  URL: 'https://reef-admin.myshopify.com' + swatchProduct.url,
                  Brand: swatchProduct.vendor,
                  Price: swatchProduct.formattedPrice,
                  CompareAtPrice: swatchProduct.formattedCompareAtPrice,
                };
                _learnq.push(['track', 'Viewed Product', itemTrack]);
                _learnq.push([
                  'trackViewedItem',
                  {
                    Title: itemTrack.Name,
                    ItemId: itemTrack.ProductID,
                    Categories: itemTrack.Categories,
                    ImageUrl: itemTrack.ImageURL,
                    Url: itemTrack.URL,
                    Metadata: {
                      Brand: itemTrack.Brand,
                      Price: itemTrack.Price,
                      CompareAtPrice: itemTrack.CompareAtPrice,
                    },
                  },
                ]);
                quickAdd.buildQuickAdd(swatchProduct);
                if (
                  productCardItem.el.querySelector('.badge__single') != null
                ) {
                  productCardItem.el.querySelector('.badge__single').remove();
                }
                let renderedBadge = productCardItem.buildBadge(
                  swatchProduct.tags,
                );
                renderedBadge
                  ? productCardItem.el
                      .querySelector('.product-card__image [data-product-link]')
                      .appendChild(renderedBadge)
                  : null;
                productCardItem.el
                  .querySelector('[data-main-image]')
                  .setAttribute('src', swatchProduct.images[0]);
                productCardItem.el
                  .querySelector('[data-main-image]')
                  .setAttribute(
                    'srcset',
                    productCardItem.buildSrcSet(swatchProduct.images[0]),
                  );
                productCardItem.el
                  .querySelector('[data-secondary-image]')
                  .setAttribute('src', swatchProduct.images[1]);
                productCardItem.el
                  .querySelector('[data-secondary-image]')
                  .setAttribute(
                    'srcset',
                    productCardItem.buildSrcSet(swatchProduct.images[1]),
                  );
                let links = productCardItem.el.querySelectorAll(
                  '[data-product-link]',
                );
                let chip = productCardItem.el.querySelector(
                  '[data-product-chip]',
                );
                if (chip) {
                  if (swatchProduct?.chip?.length > 0) {
                    chip.style.display = 'flex';
                    let chipHtml = '';
                    swatchProduct?.chip?.forEach((chipItem) => {
                      chipHtml += `<p class="product-card__chip--item">${chipItem}</p>`;
                    });
                    chip.innerHTML = chipHtml;
                  } else {
                    chip.style.display = 'none';
                  }
                }
                links.forEach((link) => {
                  link.setAttribute('href', swatchProduct.url);
                });

                productCardItem.el.querySelector(
                  '[data-product-title]',
                ).textContent = swatchProduct.title;
                productCardItem.el.querySelector(
                  '[data-product-price]',
                ).textContent = swatchProduct.formattedPrice;
                if (
                  swatchProduct.formattedCompareAtPrice &&
                  swatchProduct.formattedCompareAtPrice !=
                    swatchProduct.formattedPrice
                ) {
                  productCardItem.el
                    .querySelector('[data-product-price]')
                    .classList.add('price-item--sale--with');
                  productCardItem.el.querySelector(
                    '[data-product-compare]',
                  ).textContent = swatchProduct.formattedCompareAtPrice;
                } else {
                  productCardItem.el
                    .querySelector('[data-product-price]')
                    .classList.remove('price-item--sale--with');
                  productCardItem.el.querySelector(
                    '[data-product-compare]',
                  ).textContent = '';
                }
                productCardItem.el
                  .querySelector('.selected[data-product-swatch]')
                  .classList.remove('selected');
                e.currentTarget.classList.add('selected');
              });
              if (renderedItems == 6 && currentItemFounded) {
                let swatchItemMore = productCardItem.buildSwatchItem(
                  productCardItem.data,
                  productCardItem.allProductStyles.products.length,
                );
                swatchContainer.appendChild(swatchItemMore);
                swatchContainer.classList.add('with-more');
                break;
              }
            }
          }
        } else {
          if (timespend > 10000) {
            clearInterval(waitVariantsData);
          }
        }
      }, 2);
    }
  },

  onLoad: function (e) {
    this.initTabs();
    this.initCards();
    this.hideEmptyReviews();
  },
});
